var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconinstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11996",
    "data-name": "Path 11996",
    d: "M15.133,3.142c-4.915,0-9.583-.437-11.365,4.135-.736,1.888-.629,4.34-.629,7.852,0,3.081-.1,5.977.629,7.85,1.779,4.574,6.484,4.136,11.363,4.136,4.707,0,9.56.49,11.364-4.136.738-1.907.629-4.323.629-7.85,0-4.683.259-7.706-2.014-9.975-2.3-2.3-5.413-2.011-9.982-2.011ZM14.058,5.3C24.311,5.286,25.616,4.147,24.9,19.968c-.256,5.6-4.52,4.982-9.761,4.982-9.557,0-9.832-.273-9.832-9.827,0-9.664.758-9.816,8.756-9.824Zm7.478,1.99A1.438,1.438,0,1,0,22.975,8.73,1.439,1.439,0,0,0,21.536,7.292Zm-6.4,1.681a6.155,6.155,0,1,0,6.158,6.156,6.158,6.158,0,0,0-6.158-6.156Zm0,2.16c5.286,0,5.293,7.991,0,7.991S9.84,11.133,15.133,11.133Z",
    transform: "translate(-3.133 -3.13)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinstagram);
export default __webpack_public_path__ + "static/media/icon instagram.6dbaded8c7d79aac5a241e9fa7c89ada.svg";
export { ForwardRef as ReactComponent };